document.addEventListener('click',e=>{const t=e.target.closest('[data-mobile-toggle]');if(!t)return;const n=document.querySelector('[data-mobile-nav]');n.hidden=!n.hidden});

document.querySelectorAll('[data-product-gallery]').forEach((gallery)=>{
  const track=gallery.querySelector('[data-gallery-track]');
  const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
  const dots=[...gallery.querySelectorAll('[data-gallery-dot]')];
  const prev=gallery.querySelector('[data-gallery-prev]');
  const next=gallery.querySelector('[data-gallery-next]');
  if(!track||slides.length<2)return;

  const goTo=(index)=>{
    const safe=(index+slides.length)%slides.length;
    slides[safe].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
  };

  const activeIndex=()=>{
    const width=track.clientWidth||1;
    return Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/width)));
  };

  const updateDots=()=>{
    const current=activeIndex();
    dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===current));
  };

  prev?.addEventListener('click',()=>goTo(activeIndex()-1));
  next?.addEventListener('click',()=>goTo(activeIndex()+1));
  dots.forEach((dot)=>dot.addEventListener('click',()=>goTo(Number(dot.dataset.galleryDot)||0)));
  track.addEventListener('scroll',()=>window.requestAnimationFrame(updateDots),{passive:true});
});
